import { Box } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { currencyFormatterHelper } from '../../../../helpers/currencyFormatterHelper';
import { CURRENCY } from '../../../../config/appConfig';
import { useTranslation } from 'react-i18next';

const WavingDots = () => (
	<Box className="flex items-center gap-[3px] h-[20px]">
		{[0, 1, 2].map((i) => (
			<Box
				key={i}
				className="w-[5px] h-[5px] rounded-full bg-white"
				sx={{
					animation: 'waveDot 1.2s ease-in-out infinite',
					animationDelay: `${i * 0.15}s`,
					'@keyframes waveDot': {
						'0%, 60%, 100%': { transform: 'translateY(0)' },
						'30%': { transform: 'translateY(-6px)' },
					},
				}}
			/>
		))}
	</Box>
);

const AvailableFundsPill = ({ amount = 0, loading = false, onClick }) => {
	const { t } = useTranslation();

	return (
		<Box
			onClick={onClick}
			className="flex items-center bg-investor-bg rounded-full ps-1 pe-5 py-1 gap-3 cursor-pointer hover:opacity-95 transition-opacity min-w-[280px]">
			<Box className="flex items-center justify-center w-[38px] h-[38px] rounded-full bg-investor-green shrink-0">
				<FileDownloadOutlinedIcon className="!text-white !text-[20px]" />
			</Box>
			<Box className="text-white text-sm whitespace-nowrap">
				{t('availableFunds')}
			</Box>
			<Box className="font-bold text-white text-sm whitespace-nowrap ms-auto">
				{loading ? <WavingDots /> : `${CURRENCY} ${currencyFormatterHelper(amount)}`}
			</Box>
		</Box>
	);
};

export default AvailableFundsPill;
